import { Grid, styled } from '@mui/material';
import { IconCompanies } from 'assets/img';
import { BlockLink, LwBlock } from 'redesign';

type AgreementCardProps = {
  id: string;
  title: string;
  to: string;
};

export const AgreementCard = ({ id, title, to }: AgreementCardProps) => {
  return (
    <Grid item xs={6} md={4} lg={3}>
      <BlockLink to={to}>
        <LwBlock severity="none" id={id} title={title} icon={<StyledIconCompanies />} />
      </BlockLink>
    </Grid>
  );
};

const StyledIconCompanies = styled(IconCompanies)(() => ({
  width: '24px',
  height: '24px',
}));
